export default () => {

    var hasScroll = false;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('.new-layout-header').outerHeight();

    $(window).on('scroll', function (event) {
        hasScroll = true;
    });

    setInterval(function () {
        if (hasScroll) {
            hasScrolled();
            hasScroll = false;
        }
    }, 5);

    function hasScrolled() {
        var st = $(window).scrollTop();

        if (Math.abs(lastScrollTop - st) <= delta)
            return;

        if (st > lastScrollTop && st > navbarHeight) {
            // Scroll Down
            $('.new-layout-header').addClass('nav-up');
            $('#announcement').addClass('nav-up');
            // $('[data-account-modal]').removeClass('active') // removed this due to mobile browser behavior of rolling on changing input focus
        } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height()) {
                $('.new-layout-header').removeClass('nav-up');
                $('#announcement').removeClass('nav-up');
            }
        }

        lastScrollTop = st;
    }
}